import logo from './logo.svg';
import './App.css';
import Chat from './Chat';
function App() {
  return (
    <div className="App">
      <Chat></Chat>
    </div>
  );
}

export default App;
